import { CircularProgress } from "@material-ui/core";
import React from "react";
import { Card } from "react-bootstrap";
import { currencyFormatter } from "../../../../../../_metronic/_helpers";

export default function TotalDonation({ data = [], loading }) {
  return (
    <div className="row mb-6">
      {data.map(({ attr: { label, icon, color }, total_donation_amount }) => (
        <div className="col-lg-4 col-md-6 col-sm-12 my-4">
          <Card>
            <Card.Body>
              <div className="d-flex">
                <i className={`${icon} mr-4`} style={{ color }} />
                <h4>{label}</h4>
              </div>
              <h4 className="text-right">
                {currencyFormatter(total_donation_amount)}
              </h4>
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  );
}
